class CoreEventDispatcher {

    private _listeners:any

    constructor() {
        this._listeners = {};
    }

    addEventListener(type:string, listener:Function) {
        if (this._listeners === null) this._listeners = {};

        if (this._listeners[type] === undefined) {
            this._listeners[type] = [];
        }

        if (this._listeners[type].indexOf(listener) === -1) {
            this._listeners[type].push(listener);
        }
    }

    getListenerCount() {
        let count = 0;

        for (let key in this._listeners) {
            count += this._listeners[key].length;
        }

        return count;
    }

    hasEventListener(type, listener) {
        if (this._listeners === null) return false;

        if (this._listeners[type] !== undefined && this._listeners[type].indexOf(listener) !== -1) {
            return true;
        }

        return false;
    }

    removeEventListener(type, listener) {
        if (this._listeners === null) return;

        let listenerArray = this._listeners[type];

        if (listenerArray !== undefined) {
            let index = listenerArray.indexOf(listener);
            if (index !== -1) {
                listenerArray.splice(index, 1);
            }
        }
    }

    dispatchEvent(event) {
        if (this._listeners === null) return;

        let listenerArray = this._listeners[event.type];

        if (listenerArray !== undefined) {
            event.target = this;

//            let array = [];
            let length = listenerArray.length;
/*
            for (let i = 0; i < length; i++) {
                array[i] = listenerArray[i];
            }
*/
        for (let listener of listenerArray) {
            listener.call(this, event);
        }

         /*   for (let i = 0; i < length; i++) {
                listenerArray[i].call(this, event);
            }*/
        }
    }

    removeAllListeners() {

        if(this._listeners) {
            while(this._listeners.length > 0) {
                this._listeners.pop();
            }
            this._listeners = null;
        }

    }
}

export default CoreEventDispatcher;
